import React from 'react';
import { usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { useTrans } from '../../hooks/useTrans';
import AuthCard from '../../components/layout/auth/AuthCard';

export default function MfaEmail() {
    const translate = useTrans();
    const { flash } = usePage().props;

    return (
        <AuthCard title={translate('Bevestig je inlogverzoek')} backLink="/login">
            {flash && <Alert variant={flash.type}>{flash.description}</Alert>}

            <p>
                {translate('Voer de verificatiecode in die we naar je e-mailadres hebben gestuurd om in te loggen. Dit is ter verificatie en voor extra veiligheid. De code is 10 minuten geldig en kan maar één keer worden gebruikt.')}
            </p>

            <form method="POST" action="/login" autoComplete="off" className="mt-4">
                <input type="hidden" name="_token" value={document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''} />
                <input type="hidden" name="multi_factor_authentication_type" value="email" />

                <div className="space-y-4">
                    <Input
                        name="mfa_code"
                        placeholder={translate('Verificatiecode')}
                        className="h-[44px] font-normal"
                    />

                    <Button variant="primary" type="submit" className="w-full">
                        {translate('Inloggen met verificatiecode')}
                    </Button>

                    <Button variant="clear" type="submit" name="is_resend_mfa_email_code_request" value="1" className="w-full">
                        {translate('Nieuwe verificatiecode aanvragen')}
                    </Button>
                </div>
            </form>
        </AuthCard>
    );
}
